import { css } from "@emotion/react";
import Stack from "@mui/material/Stack";
import { theme } from "@polifonia/theme";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Select } from "@/components/Select";
import { Typography } from "@/components/Typography";

const cssFieldLabel = css`
  color: ${theme.colors.staticFgPrimary};
`;

type Frequency = "daily";

interface SyncFrequencyFieldProps {
  value: Frequency;
  onChange: (value: Frequency) => void;
  disabled?: boolean;
}

export const SyncFrequencyField: React.FC<SyncFrequencyFieldProps> =
  function SyncFrequencyField({ value, onChange, disabled = true }) {
    const { t } = useTranslation();

    const syncFrequencyOptions = useMemo(
      () => [
        { value: "daily", label: t("productFeed.urlFeed.syncFrequency.daily") },
      ],
      [t],
    );

    return (
      <Stack direction="column" gap={1}>
        <Typography variant="body" css={cssFieldLabel}>
          {t("productFeed.urlFeed.syncFrequency.label")}
        </Typography>
        <Select
          value={value}
          onChange={(v) => onChange(v as Frequency)}
          options={syncFrequencyOptions}
          disabled={disabled}
          disableClearable
        />
      </Stack>
    );
  };
